import { createRef, h, Fragment } from "preact";
import { useLayoutEffect, useState } from "preact/hooks";

import Icon from "../Icon.jsx";
import IconCopy from "../../../static/images/share_icon_copy.svg";
import IconMail from "../../../static/images/share_icon_mail.svg";
import IconGmail from "../../../static/images/share_icon_gmail.svg";
import IconOutlook from "../../../static/images/share_icon_outlook.svg";
import IconWhatsApp from "../../../static/images/share_icon_whats_app.svg";
import List from "../List.jsx";
import ListItem from "../ListItem.jsx";
import Overlay from "../Overlay.jsx";

import i18n from "../../i18n";

export default function ReferralShareDialog({
  i18nPrefix,
  onClose,
  onOpen,
  referralLink,
  user,
}) {
  const dialogRef = createRef();
  const overlayRef = createRef();
  const [showCopyNote, setShowCopyNote] = useState(false);

  function handleCopyClick() {
    navigator.clipboard.writeText(referralLink);
    clearTimeout(showCopyNote);
    setShowCopyNote(
      setTimeout(() => {
        setShowCopyNote(false);
      }, 1500)
    );
  }

  useLayoutEffect(() => {
    // TODO: Some of this stuff should belong to Overlay and some should go into a
    //       general Dialog component
    const overlay = overlayRef.current.base;
    overlay.classList.add("overlay--open");
    const wrapper = dialogRef.current;
    wrapper.classList.add("dialog--open");
    wrapper.addEventListener(
      "animationend",
      () => {
        onOpen && onOpen();
      },
      { once: true } // Does not work in IE, but who cares
    );

    return () => {
      overlay.classList.add("overlay--exit");
      wrapper.classList.add("dialog--exit");

      return new Promise(function (resolve) {
        wrapper.addEventListener("animationend", resolve);
      });
    };
  }, []);

  function handleMailClick() {
    window.open(
      `mailto:?subject=${encodeURIComponent(
        i18n.t(`${i18nPrefix}.emailSubject`)
      )}&body=${encodeURIComponent(
        i18n.t(`${i18nPrefix}.emailBody`, {
          link: referralLink,
          name: user.name,
        })
      )}`,
      "_blank"
    );
  }

  function handleGmailClick() {
    window.open(
      `https://mail.google.com/mail/?view=cm&to=&su=${encodeURIComponent(
        i18n.t(`${i18nPrefix}.emailSubject`)
      )}&body=${encodeURIComponent(
        i18n.t(`${i18nPrefix}.emailBody`, {
          link: referralLink,
          name: user.name,
        })
      )}`,
      "_blank"
    );
  }

  function handleOutlookClick() {
    window.open(
      `https://outlook.live.com/mail/0/deeplink/compose/?subject=${encodeURIComponent(
        i18n.t(`${i18nPrefix}.emailSubject`)
      )}&body=${encodeURIComponent(
        i18n.t(`${i18nPrefix}.emailBody`, {
          link: referralLink,
          name: user.name,
        })
      )}`,
      "_blank"
    );
  }

  function handleWhatsAppClick() {
    window.open(
      `https://api.whatsapp.com/send/?text=${encodeURIComponent(
        i18n.t(`${i18nPrefix}.messageText`, {
          link: referralLink,
        })
      )}`,
      "_blank"
    );
  }

  return (
    <Fragment>
      <Overlay onClose={onClose} ref={overlayRef}>
        <section class="dialog dialog--md card" ref={dialogRef}>
          <h1 class="dialog__title t-h6 t-h6--margin">
            {i18n.t(`${i18nPrefix}.title`)}
            <Icon class="dialog__closer" onClick={onClose}>
              close
            </Icon>
          </h1>

          <List>
            <ListItem iconBack={<IconCopy />} onClick={() => handleCopyClick()}>
              {i18n.t(
                showCopyNote ? `${i18nPrefix}.copied` : `${i18nPrefix}.copy`
              )}
            </ListItem>

            <ListItem iconBack={<IconMail />} onClick={() => handleMailClick()}>
              {i18n.t(`${i18nPrefix}.email`)}
            </ListItem>

            <ListItem
              iconBack={<IconGmail />}
              onClick={() => handleGmailClick()}
            >
              {i18n.t(`${i18nPrefix}.gmail`)}
            </ListItem>

            <ListItem
              iconBack={<IconOutlook />}
              onClick={() => handleOutlookClick()}
            >
              {i18n.t(`${i18nPrefix}.outlook`)}
            </ListItem>

            <ListItem
              iconBack={<IconWhatsApp />}
              onClick={() => handleWhatsAppClick()}
            >
              {i18n.t(`${i18nPrefix}.whatsApp`)}
            </ListItem>
          </List>
        </section>
      </Overlay>
    </Fragment>
  );
}
